<div class="playback-sidebar-group">
  <div
    *ngIf="!isMaximize && !hideButton"
    class="minimize mat-elevation-z4"
    (click)="onChangeSize()"
    matTooltip="Stop Events Data"
    matTooltipPosition="left">
    <mat-icon> place </mat-icon>
  </div>
  <div *ngIf="isMaximize" class="maximize mat-elevation-z4" [@slideInRight]>
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title">Stop Events Data</span>

      <button mat-icon-button class="close-button" (click)="onChangeSize()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div fxLayoutAlign="space-between center" class="search-field">
      <mat-form-field
        fxFlex="50"
        appearance="outline"
        subscriptSizing="dynamic">
        <mat-label>Select Vehicle</mat-label>
        <mat-select
          multiple="false"
          [(ngModel)]="selectedVehicle"
          #vehicleNo
          (selectionChange)="onFilterPlayback()">
          <mat-option *ngFor="let vehicle of vehicleList" [value]="vehicle">
            {{ vehicle }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <perfect-scrollbar #chatPS class="ps-sidebar" [config]="config">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="sidebar-table">
          <ng-container matColumnDef="timeStamp">
            <th mat-header-cell *matHeaderCellDef>Time Stamp</th>
            <td mat-cell *matCellDef="let element">
              <!-- {{ showTimeString(element.timeStamp) }} -->
              {{ element.timeString }}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef>Vehicle</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.busNo">{{
                element.busNo
              }}</ng-container>
              <ng-container *ngIf="element.busRegNo">{{
                element.busRegNo
              }}</ng-container>
            </td>
          </ng-container> -->
          <ng-container matColumnDef="tripId">
            <th mat-header-cell *matHeaderCellDef>Trip ID</th>
            <td mat-cell *matCellDef="let element">
              <!-- {{ showTimeString(element.timeStamp) }} -->
              {{ element.tripId }}
            </td>
          </ng-container>
          <ng-container matColumnDef="events">
            <th mat-header-cell *matHeaderCellDef>Event</th>
            <td mat-cell *matCellDef="let element" (click)="logRow(element)">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
                  <!-- *ngIf="element.eventName === 'tripstartend' || element.eventName === 'Exit' || element.eventName === 'Enter' || element.eventName === 'driverlogon' || element.eventName === 'offroute'" -->
                  <div fxFlex="1 0 auto" class="event-container">
                    <!-- {{formatEventName(element.event !== undefined ? element.event : element.eventName)}} -->
                    <b>{{ element.eventName.formatName }}</b>
                    <span class="color-brown" *ngIf="element.stopId">
                      ({{ element.stopId }})</span
                    >
                    <div class="event-text">{{ element.multilineStop }}</div>
                  </div>
                  <button
                    matTooltip="Show Location"
                    (click)="onLocate(element)"
                    mat-icon-button
                    *ngIf="
                      element.eventName !== 'textcomms' && element.latitude
                    "
                    color="primary">
                    <mat-icon>location_searching</mat-icon>
                  </button>
                  <!-- <div
                    class="material-icons"
                    *ngIf="
                      element.eventName !== 'textcomms' && element.latitude
                    "
                    (click)="onLocate(element)">
                    location_searching
                  </div> -->
                </div>

                <div
                  fxFlex="100"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  *ngIf="element.eventName === 'Missed Stops'">
                  <div class="event-container">
                    <!-- {{formatEventName(element.eventName)}} -->
                    <b>{{ element.eventName.formatName }}</b>
                    <span class="color-brown" *ngIf="element.stopId">
                      ({{ element.stopId }})</span
                    >
                    <div class="event-text">{{ element.multilineStop }}</div>
                  </div>
                  <div
                    class="material-icons mar-left-5"
                    (click)="onLocateStop(element)">
                    location_searching
                  </div>
                  <!-- <span class="color-brown" *ngIf="element.eventName === 'Enter' || element.eventName === 'Exit'" >({{element.stopId}})</span> -->
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ selected: row.isSelected }"></tr>
        </table>
      </perfect-scrollbar>
    </div>
  </div>
</div>
